import React from "react";
import { Box, Typography, Modal, Button } from "@mui/material";
import { useTranslation } from "react-i18next";

const TermsModal = ({ open, handleClose, handleAccept }) => {
  const { t } = useTranslation();

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          backgroundColor: "background.paper",
          color: "text.primary",
          p: 4,
          borderRadius: 2,
          boxShadow: 3,
          maxWidth: 600,
          mx: "auto",
          mt: 10,
        }}
      >
        <Typography variant="h5" gutterBottom>
          {t("TermsModal.title")}
        </Typography>
        <Typography variant="body1" component="p" gutterBottom>
          {t("TermsModal.description")}
        </Typography>
        <Typography variant="body1" component="p" gutterBottom sx={{ fontWeight: 'bold' }}>
          {t("TermsModal.introduction")}
        </Typography>
        <Typography variant="body2" component="p" gutterBottom>
          {t("TermsModal.introduction_description")}
        </Typography>
        <Typography variant="body1" component="p" gutterBottom sx={{ fontWeight: 'bold' }}>
          {t("TermsModal.user_responsibilities")}
        </Typography>
        <Typography variant="body2" component="p" gutterBottom>
          {t("TermsModal.user_responsibilities_description")}
        </Typography>
        <Typography variant="body1" component="p" gutterBottom sx={{ fontWeight: 'bold' }}>
          {t("TermsModal.limitation_of_liability")}
        </Typography>
        <Typography variant="body2" component="p" gutterBottom>
          {t("TermsModal.limitation_of_liability_description")}
        </Typography>
        <Typography variant="body1" component="p" gutterBottom sx={{ fontWeight: 'bold' }}>
          {t("TermsModal.governing_law")}
        </Typography>
        <Typography variant="body2" component="p" gutterBottom>
          {t("TermsModal.governing_law_description")}
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
          <Button onClick={handleClose} variant="outlined" color="primary">
            {t("TermsModal.cancel")}
          </Button>
          <Button onClick={handleAccept} variant="contained" color="primary">
            {t("TermsModal.accept")}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default TermsModal;
